import { Table } from 'antd'
import { FC, useMemo } from 'react'
import TableWrapper from '../../../../../components/table-wrapper/table-wrapper'
import { useGetRewindJobsQuery } from '../../../../../store/api/rewind-jobs-api'
import Machine from '../../../../../types/api/machine'
import { rewindJobsQuery } from '../../constants/query-params'
import { getColumns } from './columns'
import './rewind-jobs.css'

interface RewindJobsProps {
    machines: Machine[]
}

const RewindJobs: FC<RewindJobsProps> = ({ machines }) => {
    const { data, isLoading } = useGetRewindJobsQuery(rewindJobsQuery)
    const columns = useMemo(() => getColumns(machines), [machines])

    return (
        <TableWrapper tableHasNotPagination>
            <Table
                dataSource={data?.data || []}
                columns={columns}
                pagination={false}
                rowKey='id'
                size='small'
                loading={isLoading}
                rowClassName={() => 'rewind-secondary-row'}
            />
        </TableWrapper>
    )
}

export default RewindJobs
